import { render } from "./dataLoad.vue?vue&type=template&id=5b6c8d2b&scoped=true&ts=true"
import script from "./dataLoad.vue?vue&type=script&lang=ts"
export * from "./dataLoad.vue?vue&type=script&lang=ts"

import "./dataLoad.vue?vue&type=style&index=0&id=5b6c8d2b&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6c8d2b"]])

export default __exports__